// extracted by mini-css-extract-plugin
module.exports = {"button":"_3gYenw","circle":"_3gap2-","stroke":"_2263r0","withLabelButton":"_1mJUGr","buttonIcon":"_3xz_AX","downloadAction":"_1r-8s_","dropListLabel":"_1Ms-w3"};